// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Normal document flow. Do not position:absolute header/bank blocks. */

.pf,
.pf-head,
.pf-bank,
.pf-foot,
.pf-name,
.pf-email {
  position: static;
}

.pf {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: var(--paper);
}

.pf-head {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px 20px 16px;
}

.pf-name {
  margin: 0;
  font-family: var(--font-display);
  font-weight: 400;
  font-size: 2rem;
  line-height: 1.2;
  letter-spacing: -0.03em;
  color: var(--ink);
}

.pf-status {
  display: inline-block;
  align-self: flex-start;
  font-family: var(--font-mono);
  font-size: 10px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--ok);
  border: 1px solid var(--ok);
  padding: 2px 8px;
}

.pf-email {
  margin: 0;
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--ink-2);
}

.pf-bank {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 20px 24px;
  border-top: 1px solid var(--rule-soft);
}

.pf-bank__title {
  margin: 16px 0 0;
  font-family: var(--font-display);
  font-weight: 400;
  font-size: 1.15rem;
  letter-spacing: -0.02em;
  color: var(--ink);
}

.pf-bank__sub {
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: var(--ink-3);
}

.pf-bank__empty {
  margin: 0;
  font-size: 13px;
  color: var(--ink-3);
}

.pf-account {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 0;
  border-top: 1px solid var(--rule-soft);
}

.pf-account:first-of-type {
  border-top: none;
  padding-top: 4px;
}

.pf-account__bank {
  font-family: var(--font-display);
  font-size: 1rem;
  color: var(--ink);
}

.pf-account__pan {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--ink-2);
}

.pf-account__meta {
  font-size: 13px;
  color: var(--ink-3);
}

.pf-account .pf-account__edit {
  margin-left: -12px;
  align-self: flex-start;
  min-height: 44px;
  min-width: 44px;
}

.pf-bank > .btn,
.pf-foot > .btn {
  min-height: 44px;
}

.pf-bank__loading {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pf-principal {
  display: inline-block;
  margin-left: 8px;
  font-family: var(--font-mono);
  font-size: 9px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--ok);
  border: 1px solid var(--ok);
  padding: 1px 6px;
}

.pf-foot {
  margin-top: auto;
  padding: 8px 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Desktop: the same page column as the request detail (a rule under a compact
   header, then the content as cards). Title, status and email share a row. */
@media (min-width: 1024px) {
  .pf-shell .pf {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: var(--receptor-page-max, 1200px);
    min-height: 0;
    margin: 0 auto;
    padding: 8px 0 32px;
    background: transparent;
  }

  .pf-shell .pf-head {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: baseline;
    column-gap: 20px;
    row-gap: 4px;
    margin-bottom: 24px;
    padding: 0 0 20px;
    border-bottom: 1px solid var(--rule);
    min-width: 0;
  }

  .pf-shell .pf-name {
    font-size: var(--fs-h2);
    overflow-wrap: anywhere;
  }

  .pf-shell .pf-status {
    align-self: center;
  }

  .pf-shell .pf-email,
  .pf-shell .pf-account__bank,
  .pf-shell .pf-account__pan,
  .pf-shell .pf-account__meta {
    overflow-wrap: anywhere;
  }

  .pf-shell .pf-bank {
    width: 100%;
    max-width: 560px;
    min-width: 0;
    gap: 12px;
    border: 1px solid var(--rule);
    background: var(--surface);
    padding: 24px;
  }

  .pf-shell .pf-bank__title {
    font-size: var(--fs-title-sm);
    margin: 0;
  }

  .pf-shell .pf-account {
    padding: 16px 0 0;
  }

  .pf-shell .pf-account:first-of-type {
    padding-top: 4px;
  }

  /* The way out lives in the rail on desktop. */
  .pf-shell .pf-foot {
    display: none;
  }

  .pf-shell .pf-bank__empty {
    padding: 24px;
    border: 1px dashed var(--rule);
    color: var(--ink-2);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/perfil/Perfil.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE;;;;;;EAME,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;6EAC6E;AAC7E;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,2CAA2C;IAC3C,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,oCAAoC;IACpC,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;;IAIE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,6BAA6B;IAC7B,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,6BAA6B;IAC7B,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,8CAA8C;EAC9C;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;AACF","sourcesContent":["/* Normal document flow. Do not position:absolute header/bank blocks. */\n\n.pf,\n.pf-head,\n.pf-bank,\n.pf-foot,\n.pf-name,\n.pf-email {\n  position: static;\n}\n\n.pf {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  background: var(--paper);\n}\n\n.pf-head {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 24px 20px 16px;\n}\n\n.pf-name {\n  margin: 0;\n  font-family: var(--font-display);\n  font-weight: 400;\n  font-size: 2rem;\n  line-height: 1.2;\n  letter-spacing: -0.03em;\n  color: var(--ink);\n}\n\n.pf-status {\n  display: inline-block;\n  align-self: flex-start;\n  font-family: var(--font-mono);\n  font-size: 10px;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--ok);\n  border: 1px solid var(--ok);\n  padding: 2px 8px;\n}\n\n.pf-email {\n  margin: 0;\n  font-family: var(--font-mono);\n  font-size: 12px;\n  color: var(--ink-2);\n}\n\n.pf-bank {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 8px 20px 24px;\n  border-top: 1px solid var(--rule-soft);\n}\n\n.pf-bank__title {\n  margin: 16px 0 0;\n  font-family: var(--font-display);\n  font-weight: 400;\n  font-size: 1.15rem;\n  letter-spacing: -0.02em;\n  color: var(--ink);\n}\n\n.pf-bank__sub {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.4;\n  color: var(--ink-3);\n}\n\n.pf-bank__empty {\n  margin: 0;\n  font-size: 13px;\n  color: var(--ink-3);\n}\n\n.pf-account {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 16px 0;\n  border-top: 1px solid var(--rule-soft);\n}\n\n.pf-account:first-of-type {\n  border-top: none;\n  padding-top: 4px;\n}\n\n.pf-account__bank {\n  font-family: var(--font-display);\n  font-size: 1rem;\n  color: var(--ink);\n}\n\n.pf-account__pan {\n  font-family: var(--font-mono);\n  font-size: 12px;\n  color: var(--ink-2);\n}\n\n.pf-account__meta {\n  font-size: 13px;\n  color: var(--ink-3);\n}\n\n.pf-account .pf-account__edit {\n  margin-left: -12px;\n  align-self: flex-start;\n  min-height: 44px;\n  min-width: 44px;\n}\n\n.pf-bank > .btn,\n.pf-foot > .btn {\n  min-height: 44px;\n}\n\n.pf-bank__loading {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.pf-principal {\n  display: inline-block;\n  margin-left: 8px;\n  font-family: var(--font-mono);\n  font-size: 9px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--ok);\n  border: 1px solid var(--ok);\n  padding: 1px 6px;\n}\n\n.pf-foot {\n  margin-top: auto;\n  padding: 8px 20px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* Desktop: the same page column as the request detail (a rule under a compact\n   header, then the content as cards). Title, status and email share a row. */\n@media (min-width: 1024px) {\n  .pf-shell .pf {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    max-width: var(--receptor-page-max, 1200px);\n    min-height: 0;\n    margin: 0 auto;\n    padding: 8px 0 32px;\n    background: transparent;\n  }\n\n  .pf-shell .pf-head {\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: baseline;\n    column-gap: 20px;\n    row-gap: 4px;\n    margin-bottom: 24px;\n    padding: 0 0 20px;\n    border-bottom: 1px solid var(--rule);\n    min-width: 0;\n  }\n\n  .pf-shell .pf-name {\n    font-size: var(--fs-h2);\n    overflow-wrap: anywhere;\n  }\n\n  .pf-shell .pf-status {\n    align-self: center;\n  }\n\n  .pf-shell .pf-email,\n  .pf-shell .pf-account__bank,\n  .pf-shell .pf-account__pan,\n  .pf-shell .pf-account__meta {\n    overflow-wrap: anywhere;\n  }\n\n  .pf-shell .pf-bank {\n    width: 100%;\n    max-width: 560px;\n    min-width: 0;\n    gap: 12px;\n    border: 1px solid var(--rule);\n    background: var(--surface);\n    padding: 24px;\n  }\n\n  .pf-shell .pf-bank__title {\n    font-size: var(--fs-title-sm);\n    margin: 0;\n  }\n\n  .pf-shell .pf-account {\n    padding: 16px 0 0;\n  }\n\n  .pf-shell .pf-account:first-of-type {\n    padding-top: 4px;\n  }\n\n  /* The way out lives in the rail on desktop. */\n  .pf-shell .pf-foot {\n    display: none;\n  }\n\n  .pf-shell .pf-bank__empty {\n    padding: 24px;\n    border: 1px dashed var(--rule);\n    color: var(--ink-2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
